import React from 'react';
const FolderSVG = ({ color = 'black', className, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="27"
      height="23"
      viewBox="0 0 27 23"
      fill="none"
      {...props}
      className={className}
    >
      <path
        d="M11.4167 5.24998L9.33333 1.08331H1V5.24998V21.9166H26V5.24998H11.4167Z"
        stroke={color}
        strokeWidth="1.1"
      />
    </svg>
  );
};

export default FolderSVG;
